import {Provider} from '@angular/core';

import {EmployeeBusinessService} from 'DBadgeEmployee-app/src/app/core/services/business.service';
import {ProfileEmployeeService} from './profile-employee.service';
import {ProfileSecurityAdminService} from './profile-security.service';
import {ProfileService} from './profile.service';
import {UserRoleEnum} from '@shared-models/common.enums';

export function ProfileGridFactory(businessService: EmployeeBusinessService): ProfileService {

    switch (businessService.userRoleService.getRole()) {
        case UserRoleEnum.Security:
        case UserRoleEnum.SecurityUS:
        case UserRoleEnum.SecurityUSI:
            return new ProfileSecurityAdminService(businessService);
        default:
            return new ProfileEmployeeService(businessService);
    }
}

export const PROFILE_PROVIDER: Provider = {
    provide: ProfileService,
    useFactory: ProfileGridFactory,
    deps: [
        EmployeeBusinessService
    ]
};
